import { z } from 'zod';

import { BorrowerAchAccountId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils';

export const BorrowerAchAccount = z.object({
  id: zodBrandedUuid<BorrowerAchAccountId>(),
  accountName: z.string(),
  lastFour: z.string(),
  prenoteSubmittedAt: zodDateOrString.optional(),
  disabledAt: zodDateOrString.optional(),
  addedByCompany: z.boolean(),
  createdAt: z.date(),
});
export type BorrowerAchAccount = z.infer<typeof BorrowerAchAccount>;
